var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FEBC2E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6149_10772",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 44,
    height: 44
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 44,
    height: 44,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6149_10772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.575 46.5C40.7556 46.5 36.9819 45.6674 33.2542 44.0021C29.5264 42.3368 26.1347 39.9764 23.0792 36.9208C20.0236 33.8653 17.6632 30.4736 15.9979 26.7458C14.3326 23.0181 13.5 19.2444 13.5 15.425C13.5 14.875 13.6833 14.4167 14.05 14.05C14.4167 13.6833 14.875 13.5 15.425 13.5H22.85C23.2778 13.5 23.6597 13.6451 23.9958 13.9354C24.3319 14.2257 24.5306 14.5694 24.5917 14.9667L25.7833 21.3833C25.8444 21.8722 25.8292 22.2847 25.7375 22.6208C25.6458 22.9569 25.4778 23.2472 25.2333 23.4917L20.7875 27.9833C21.3986 29.1139 22.1243 30.2063 22.9646 31.2604C23.8049 32.3146 24.7292 33.3306 25.7375 34.3083C26.6847 35.2556 27.6778 36.134 28.7167 36.9438C29.7556 37.7535 30.8556 38.4944 32.0167 39.1667L36.325 34.8583C36.6 34.5833 36.959 34.3771 37.4021 34.2396C37.8451 34.1021 38.2806 34.0639 38.7083 34.125L45.0333 35.4083C45.4611 35.5306 45.8125 35.7521 46.0875 36.0729C46.3625 36.3938 46.5 36.7528 46.5 37.15V44.575C46.5 45.125 46.3167 45.5833 45.95 45.95C45.5833 46.3167 45.125 46.5 44.575 46.5Z",
    fill: "#011949"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/CallIcon.6e9e3b96bd2283ee76fc97662df2fce3.svg";
export { ForwardRef as ReactComponent };